const _milestoneData = {
  totalCheerCount: 0,
  winCheerCount: 0,
  betMilestones: [
    {
      milestoneId: 1,
      milestoneType: 1,
      targetCount: 5,
      status: 0,
      propInfo: '[{"propId":90301905,"propCount":1,"expiredDay":0,"propName":"頭像框"}]',
    },
    {
      milestoneId: 2,
      milestoneType: 1,
      targetCount: 10,
      status: 0,
      propInfo: '[{"propId":70100004,"propCount":10000,"expiredDay":0,"propName":"點券"}]',
    },
    {
      milestoneId: 3,
      milestoneType: 1,
      targetCount: 20,
      status: 0,
      propInfo: '[{"propId":32204003,"propCount":1,"expiredDay":7,"propName":"中級安全箱 (7天）"}]',
    },
    {
      milestoneId: 4,
      milestoneType: 1,
      targetCount: 30,
      status: 0,
      propInfo: '[{"propId":90501207,"propCount":1,"expiredDay":0,"propName":"稱號"}]',
    },
    {
      milestoneId: 5,
      milestoneType: 1,
      targetCount: 40,
      status: 0,
      propInfo: '[{"propId":70100011,"propCount":1500000,"expiredDay":0,"propName":"金幣"}]',
    },
    {
      milestoneId: 6,
      milestoneType: 1,
      targetCount: 50,
      status: 0,
      propInfo: '[{"propId":20400904,"propCount":1,"expiredDay":0,"propName":"掛飾-哨子"}]',
    },
    {
      milestoneId: 7,
      milestoneType: 1,
      targetCount: 60,
      status: 0,
      propInfo: '[{"propId":70100004,"propCount":30000,"expiredDay":0,"propName":"點券"}]',
    },
    {
      milestoneId: 8,
      milestoneType: 1,
      targetCount: 70,
      status: 0,
      propInfo: '[{"propId":70100101,"propCount":20,"expiredDay":0,"propName":"金鑽"}]',
    },
    {
      milestoneId: 9,
      milestoneType: 1,
      targetCount: 80,
      status: 0,
      propInfo: '[{"propId":70100011,"propCount":2000000,"expiredDay":0,"propName":"金幣"}]',
    },
    {
      milestoneId: 10,
      milestoneType: 1,
      targetCount: 90,
      status: 0,
      propInfo: '[{"propId":80102101,"propCount":10,"expiredDay":0,"propName":"金鑽抽獎券"}]',
    },
    {
      milestoneId: 11,
      milestoneType: 1,
      targetCount: 100,
      status: 0,
      propInfo: '[{"propId":70100014,"propCount":2,"expiredDay":0,"propName":"秘寶鈅匙"}]',
    },
  ],
  winMilestones: [
    {
      milestoneId: 12,
      milestoneType: 2,
      targetCount: 1,
      status: 0,
      propInfo: '[{"propId":90105303,"propCount":1,"expiredDay":0,"propName":"頭像"}]',
    },
    {
      milestoneId: 13,
      milestoneType: 2,
      targetCount: 3,
      status: 0,
      propInfo: '[{"propId":70100004,"propCount":10000,"expiredDay":0,"propName":"點券"}]',
    },
    {
      milestoneId: 14,
      milestoneType: 2,
      targetCount: 6,
      status: 0,
      propInfo: '[{"propId":80102101,"propCount":5,"expiredDay":0,"propName":"金鑽抽獎券"}]',
    },
    {
      milestoneId: 15,
      milestoneType: 2,
      targetCount: 10,
      status: 0,
      propInfo: '[{"propId":70100011,"propCount":1000000,"expiredDay":0,"propName":"金幣"}]',
    },
    {
      milestoneId: 16,
      milestoneType: 2,
      targetCount: 15,
      status: 0,
      propInfo: '[{"propId":70100014,"propCount":1,"expiredDay":0,"propName":"秘寶鈅匙"}]',
    },
    {
      milestoneId: 17,
      milestoneType: 2,
      targetCount: 20,
      status: 0,
      propInfo: '[{"propId":70100011,"propCount":3000000,"expiredDay":0,"propName":"金幣"}]',
    },
    {
      milestoneId: 18,
      milestoneType: 2,
      targetCount: 25,
      status: 0,
      propInfo: '[{"propId":70100004,"propCount":100000,"expiredDay":0,"propName":"點券"}]',
    },
    {
      milestoneId: 19,
      milestoneType: 2,
      targetCount: 30,
      status: 0,
      propInfo: '[{"propId":20500901,"propCount":1,"expiredDay":0,"propName":"準星線-足球"}]',
    },
    {
      milestoneId: 20,
      milestoneType: 2,
      targetCount: 35,
      status: 0,
      propInfo: '[{"propId":70100004,"propCount":200,"expiredDay":0,"propName":"槍械三階升級卡"}]',
    },
    {
      milestoneId: 21,
      milestoneType: 2,
      targetCount: 40,
      status: 0,
      propInfo: '[{"propId":81010999,"propCount":100,"expiredDay":0,"propName":"萬能成長幣"}]',
    },
    {
      milestoneId: 22,
      milestoneType: 2,
      targetCount: 50,
      status: 0,
      propInfo: '[{"propId":70100014,"propCount":5,"expiredDay":0,"propName":"秘寶鈅匙"}]',
    },
  ],
};

export const milestoneData = JSON.parse(JSON.stringify(_milestoneData));